import React, { useState } from "react";
import { tutorRows } from "../../Pages/About/components/data";
import MarqueePauseButton from "../../common/MarqueePauseButton";

// Under the pricing: the people they will learn from, as the About page's
// rotating cast, so the proof is in view when the price is. Each row is
// drawn twice so it can scroll without a seam; the copy is hidden from
// screen readers, and with reduced motion only the first is shown. The
// button stops the rows for anyone without a mouse to hover with.
const Cast = () => {
  const [paused, setPaused] = useState(false);

  return (
    <section
      className={`home-cast${paused ? " home-cast--paused" : ""}`}
      aria-labelledby="home-cast-title"
    >
      <div className="container">
        <h2 className="section-title home-cast__title" id="home-cast-title">
          Learn from the people who <em>wrote the book</em>.
        </h2>
      </div>
      <div className="home-cast__marquee">
        {tutorRows.map((row, index) => (
          <div
            className={`home-cast__row${index % 2 === 1 ? " home-cast__row--reverse" : ""}`}
            key={index}
          >
            {[0, 1].map((copy) => (
              <ul
                className={`home-cast__set${copy === 1 ? " home-cast__set--copy" : ""}`}
                aria-hidden={copy === 1 ? true : undefined}
                key={copy}
              >
                {row.map((tutor) => (
                  <li className="home-cast__chip" key={tutor.name}>
                    <span className="home-cast__name">{tutor.name}</span>
                    <span className="home-cast__role">{tutor.title}</span>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        ))}
      </div>
      <div className="home-cast__controls">
        <MarqueePauseButton paused={paused} onToggle={() => setPaused(!paused)} />
      </div>
    </section>
  );
};

export default Cast;
